import { useLanguage } from "../../LanguageContext";
import GlitchText from "../GlitchText";

export default function BrandName() {
	const { text } = useLanguage();
	const first = text.site.displayName[0];
	const last = text.site.displayName[1];

	return (
		<GlitchText
			text={`${first}${last}`}
			lines={[first, last]}
			as="h2"
			className="footer-brand-name"
			stageClassName="footer-brand-stage"
			ariaLabel={`${first} ${last}`}
		/>
	);
}
